import ZHero from './ZHero.vue'
export default ZHero
